import React from 'react';
import classNames from 'classnames';
import { Container } from 'components/shared';
import { APP_NAME } from 'constants/app.constant';
import { PAGE_CONTAINER_GUTTER_X } from 'constants/theme.constant';
import packagejson from '../../../package.json';
const version = packagejson.version;

const FooterContent = () => {
  return (
    <div className="flex items-center justify-between flex-auto w-full">
      <span>
        Copyright &copy; {`${new Date().getFullYear()}`}{' '}
        <span className="font-semibold">{`${APP_NAME}`}</span> Todos os direitos
        reservados. Versão: {version}
      </span>
      <div className="">
        {/* <a className="text-gray" href="/politicas-de-privacidade" onClick={(e) => e.preventDefault()}>
          Termos de uso
        </a>
        <span className="mx-2 text-muted"> | </span> */}
        <a className="text-gray" href="/politicas-de-privacidade" onClick={(e) => e.preventDefault()}>
          Políticas de privacidade
        </a>
      </div>
    </div>
  );
};

export default function Footer({ pageContainerType }) {
  return (
    <footer
      className={classNames(
        `footer flex flex-auto items-center h-16 ${PAGE_CONTAINER_GUTTER_X}`
      )}
    >
      {pageContainerType === 'contained' ? (
        <Container>
          <FooterContent />
        </Container>
      ) : (
        <FooterContent />
      )}
    </footer>
  );
}
